// extracted by mini-css-extract-plugin
export default {"instruction-content":"InstructionContent_instruction-content__E5CQi"};